<template>
  <Modal ref="modal" class="modal-inquiry-archive" :actions="actions" @action="handleAction" immediate>
    <h1>Fall wiedereröffnen</h1>
    <p>Wollen Sie den Fall wirklich wiedereröffnen?</p>
  </Modal>
</template>

<script>
  import Modal from '@/components/ui/Modal';
  import Select from '@/components/ui/inputs/Select';
  import InquiryStatus from '@/objects/InquiryStatus';

  export default {
    name: 'ModalInquiryReopen',
    components: {
      Select,
      Modal,
    },
    //---------------------------------------------------
    //
    //  Properties
    //
    //---------------------------------------------------
    props: {
      uuid: {
        type: String,
        default: null,
      },
    },
    //---------------------------------------------------
    //
    //  Data model
    //
    //---------------------------------------------------
    data() {
      return {};
    },
    //---------------------------------------------------
    //
    //  Computed Properties
    //
    //---------------------------------------------------
    computed: {
      actions() {
        const i18n = this.$i18n;
        return [
          { value: 'cancel', label: i18n.t('labels.cancel') },
          { value: 'reopen', label: i18n.t('labels.reopen') },
        ];
      },
    },
    //---------------------------------------------------
    //
    //  Watch Properties
    //
    //---------------------------------------------------
    watch: {},
    //---------------------------------------------------
    //
    //  Filter Properties
    //
    //---------------------------------------------------
    // filters: {},
    //---------------------------------------------------
    //
    //  Validation Properties
    //
    //---------------------------------------------------
    // validations: {},
    //---------------------------------------------------
    //
    //  Vue Lifecycle
    //
    //---------------------------------------------------
    // beforeCreate() {},
    // async created() {},
    // beforeMount() {},
    // render(h) { return h(); },
    // mounted() {},
    // beforeUpdate() {},
    // updated() {},
    // beforeDestroy() {},
    // destroyed() {},
    //---------------------------------------------------
    //
    //  Methods
    //
    //---------------------------------------------------
    methods: {
      //----------------------------------
      // Event Handlers
      //----------------------------------
      async handleAction(action) {
        if (action === 'reopen') {
          const uuid = this.uuid;
          const response = await this.$sav.api.post('/inquiry/status', null, {
            uuid,
            status: InquiryStatus.PROGRESS_COMPLETE,
          });
          if (response) {
            this.$emit('done');
          }
        }
        this.$refs.modal.close();
      },
    },
  };
</script>

<style lang="scss">
@import '~scss/mixins';
@import '~scss/variables';

.modal-inquiry-archive {
  h1 {
    margin-bottom: 12px;
  }

  p {
    @include font-body-medium;
    color: $color-black-solid-100;
  }

  form {
    padding: 24px 0;

    .group {
      margin-bottom: 24px;
      &:last-of-type {
        margin-bottom: 0;
      }
    }

    hr {
      border: 0;
      margin: 24px 0;
      border-bottom: 1px solid $color-black-alpha-10;
    }
  }
}
</style>
